import React from 'react';
import { PaymentModal } from './pages/PaymentModal';
export function App() {
  return <div className="min-h-screen w-full relative" data-id="element-0">
      {/* Background Image Layer */}
      <div className="absolute inset-0 bg-cover bg-center z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
    }} data-id="element-1" />

      {/* Dark Overlay with Blur */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-10" data-id="element-2" />

      {/* Content Layer */}
      <div className="relative z-20 min-h-screen w-full flex items-center justify-center p-4 overflow-y-auto" data-id="element-3">
        <PaymentModal data-id="element-4" />
      </div>
    </div>;
}